import React from 'react';

import { Outlet } from 'react-router';

import { PageLayout } from 'src/components/common';
import { PeosDetailLayout } from 'src/layouts/PeosDetailLayout';
import { SxProp } from 'src/types/mui';

export const PeosDetailOutlet: React.FC = () => {
  return (
    <PageLayout titleContent="PEO Details" paperSx={{ mt: 5 }} containerSx={pageLayoutContainerSx}>
      <PeosDetailLayout>
        <Outlet />
      </PeosDetailLayout>
    </PageLayout>
  );
};

const pageLayoutContainerSx: SxProp = {
  overflow: 'inherit',
};
